module.exports = __webpack_public_path__ + "static/media/skill.34409398.svg";